import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import './retail.scss';
import AOS from "aos";
import "aos/dist/aos.css";

export default function RetailSummary() {

  useEffect(() => {
    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <h5>Retail Industry Summary</h5>
      <ul className="financial-listing">
        <li>After financial businesses, retail companies <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>use the most channels in their campaigns.</span></li>
        <li>Retail companies are the <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>most likely to use social media along with direct mail.</span></li>
        <li>They rate direct mail to be <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>less effective than all the other industries surveyed.</span> Perhaps relatedly, they also report having <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>low expertise with mail.</span></li>
        <li>Out of all direct mail techniques, retail companies <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>use personalized offers the most.</span></li>
      </ul>
    </>
  );
}
